import ConfigurationHistoryTable from "../../components/history-table/configuration-history-table.component";
import {
  getTimerProfileHistory,
  getTimerProfileHistoryDetail,
} from "src/core/api/services/command-module/timer-profile.service";
import type { TimerProfileHistoryItem } from "../../components/types";

type TimerProfileHistoryProps = {
  assetCode: string | null;
  isOpen: boolean;
  handleClose: () => void;
  data?: TimerProfileHistoryItem[];
  isLoading?: boolean;
  refetchTrigger?: number;
};

export function TimerProfileHistory({
  assetCode,
  isOpen,
  handleClose,
  data,
  isLoading,
  refetchTrigger,
}: TimerProfileHistoryProps) {
  return (
    <ConfigurationHistoryTable
      isOpen={isOpen}
      handleClose={handleClose}
      assetCode={assetCode}
      title="Timer Profile History"
      subtitle="Last 13 months"
      retainedText="Retained for 13 Months"
      actionColumnTitle="Profile Action"
      actionTitleField="title"
      issueTimeField="sentOn"
      acknowledgeTimeField="ackTime"
      defaultSortBy="SentOn"
      queryKey="getTimerProfileHistory"
      getHistory={getTimerProfileHistory}
      getHistoryDetail={getTimerProfileHistoryDetail}
      fallbackData={data}
      fallbackIsLoading={isLoading}
      refetchTrigger={refetchTrigger}
    />
  );
}
